<template>
  <Head>
    <title>{{ title }}</title>
    <meta
      head-key="description"
      name="description"
      content="Outil d'autodiagnostic municipal en gestion durable des eaux pluviales"
    />
    <slot />
  </Head>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue'

export default {
  components: {
    Head,
  },
  props: {
    title: {
      type: String,
      default: "S'évaluer - GDEP - Gestion Des Eaux Pluviales",
    },
  },
}
</script>
